// src/lib/fsReads.js
export function incFsReads(n = 1) {
  if (typeof window === "undefined") return;
  window.__fsReads = (window.__fsReads || 0) + n;
}
export function getFsReads() {
  if (typeof window === "undefined") return 0;
  return window.__fsReads || 0;
}
export function resetFsReads() {
  if (typeof window === "undefined") return;
  window.__fsReads = 0;
}